import React from 'react';

function TudoConversorLogo({ className = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative w-10 h-10 flex items-center justify-center bg-white rounded-xl shadow-sm border border-white/20">
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          className="w-6 h-6 text-primary"
          width="24"
          height="24"
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M4 14l6-6 6 6" />
          <path d="M10 20V8" />
          <path d="M20 10l-6 6-6-6" opacity="0.4" />
          <path d="M14 4v12" opacity="0.4" />
        </svg>
      </div>
      <div className="flex flex-col">
        <span className="text-xl font-bold tracking-tight text-white leading-none">
          Tudo Conversor
        </span>
      </div>
    </div>
  );
}

export default TudoConversorLogo;